import { render } from "./DocumentationComponent.vue?vue&type=template&id=c4e7e194&scoped=true"
import script from "./DocumentationComponent.vue?vue&type=script&lang=js"
export * from "./DocumentationComponent.vue?vue&type=script&lang=js"

import "./DocumentationComponent.vue?vue&type=style&index=0&id=c4e7e194&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e7e194"]])

export default __exports__